import md5 from 'crypto-js/md5';
import cacheStorage from 'legacy/cache/CacheStorage';
import store from 'store/index';

// set at Webpack level
const buildVersion = BUILD_VERSION; // eslint-disable-line no-undef

const projectId = () => store.getters['projects/currentProjectId'];


class CacheService {
  constructor (cacheStorage) {
    this.storage = cacheStorage;
    this.cachedPromises = {};
    this.checkCacheVersion(buildVersion);
  }

  checkCacheVersion (version) {
    if (this.storage.getStorageVersion() !== version) {
      this.storage.flushCache();
      this.storage.setVersion(version);
    }
  }

  makeCacheKey ({key, funcArgs, onProjectLevel}) {
    let cacheKey = key;
    if (onProjectLevel) {
      cacheKey = `${cacheKey}-proj-${projectId()}`;
    }
    cacheKey = `${cacheKey}-${md5(JSON.stringify(funcArgs))}`;
    return cacheKey;
  }

  getCache (cacheKey) {
    return this.storage.get(cacheKey);
  }

  getCachedPromise (cacheKey) {
    return this.cachedPromises[cacheKey];
  }

  cachePromise (cacheKey, promise) {
    this.cachedPromises[cacheKey] = promise;
    const removeFromPromiseCache = () => {
      delete this.cachedPromises[cacheKey];
    };

    // remove promise from cache after its resolve
    promise.then(removeFromPromiseCache, removeFromPromiseCache);
  }

  setCache (cacheKey, value, params) {
    this.storage.set(cacheKey, value, params);
  }

  async asyncTryCacheOrCall ({func, key, funcArgs = {}, onProjectLevel = false, ttl = 120}, resetCache) {
    const cacheKey = this.makeCacheKey({func, key, funcArgs, onProjectLevel});

    const cachedResult = this.getCache(cacheKey);
    if (cachedResult && !resetCache) {
      // return empty data if cache is empty
      if (Array.isArray(cachedResult) && cachedResult.length === 0) {
        return {
          items: [],
          items_total: 0,
          total: {}
        };
      }
      return cachedResult;
    }

    const cachedPromise = this.getCachedPromise(cacheKey);
    if (cachedPromise) {
      return cachedPromise;
    }

    const promise = func(funcArgs);
    this.cachePromise(cacheKey, promise);
    const data = await promise;
    this.setCache(cacheKey, data, {ttl});
    return data;
  }

}

export default new CacheService(cacheStorage);
